import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { Toolbar } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SubmitButton,
} from "@websential/cosmic-v20";
// import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
// import { EnhancedButtonPrimeReactSeverity } from "../../../common/Common";

export interface IAdminEarningsSetupToolbar {
	onResetClicked: () => void;
	onDeleteClicked: () => void;
	isSubmitting: boolean;
	id?: any;
}

export const AdminEarningsSetupToolbar: FC<IAdminEarningsSetupToolbar> = ({
	onResetClicked,
	onDeleteClicked,
	isSubmitting = false,
	id,
}) => {
	return (
		<Toolbar>
			<>
				<EnhancedButtonPrimeReact
					label="Submit"
					loading={isSubmitting}
					type="submit"
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-plus"
					label="Reset"
					raised
					onClickHandler={onResetClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</>
		</Toolbar>
	);
};
